import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CbreLoggerModule, CbreLoggerToken } from '@cbre/logger';
import { CbreHttpConfig, CbreHttpConfigToken } from './cbre-http.config';
import { HttpSpanInterceptorService } from './interceptors/http-span-interceptor.service';
import { HttpMethods } from './services/http-methods.service';
import { HttpStreamsService } from './services/http-streams.service';

@NgModule({
  declarations: [],
  exports: [],
  imports: [CbreLoggerModule],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class CbreHttpModule {
  static forRoot(options: CbreHttpConfig): ModuleWithProviders<CbreHttpModule> {
    return {
      ngModule: CbreHttpModule,
      providers: [
        { provide: CbreHttpConfigToken, useValue: options },
        {
          // add stats, transaction and span-ing interceptor
          provide: HTTP_INTERCEPTORS,
          useClass: HttpSpanInterceptorService,
          multi: true,
          deps: [CbreHttpConfigToken, CbreLoggerToken],
        },
        HttpMethods,
        HttpStreamsService,
      ],
    };
  }
}
